// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio-status-active {
  background-color: #a9dfbf;
  color: #495057;
  font-weight: normal;
}

.portfolio-status-inactive {
  background-color: #f2f4f4;
  color: #495057;
  font-weight: normal;
}
`, "",{"version":3,"sources":["webpack://./src/scene-d/PostPortfolio/PostPortfolioView/PostPortfolioInformation/LocalComponents/LocalComponents.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".portfolio-status-active {\n  background-color: #a9dfbf;\n  color: #495057;\n  font-weight: normal;\n}\n\n.portfolio-status-inactive {\n  background-color: #f2f4f4;\n  color: #495057;\n  font-weight: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
